import styled from "styled-components";

const MainWrapper = styled.div`
  margin: 0 auto 64px auto;
  max-width: 1400px;
  padding: 0 16px;
`;

export default MainWrapper;